import { useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';

// Custom component to handle map clicks
const MapClickHandler = ({ onMapClick, isSelectingLocation }) => {
  const map = useMapEvents({
    click: (e) => {
      if (isSelectingLocation) {
        onMapClick(e.latlng);
      }
    }
  });
  
  // Change cursor when in selection mode
  useEffect(() => {
    const container = map.getContainer();
    if (isSelectingLocation) {
      container.style.cursor = 'crosshair';
    } else {
      container.style.cursor = '';
    }
  }, [isSelectingLocation, map]);
  
  return null;
};

export default MapClickHandler; 